import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { ProductTraitClient, ProductTraitDto } from 'src/app/core/services/service-clients';
import { firstValueFrom } from 'rxjs';

interface ProductTraitState {
  productTraits: ProductTraitDto[];
  loading: boolean;
}

const initialState: ProductTraitState = {
  productTraits: [],
  loading: false
};

export const productTraitStore = signalStore(
  withState<ProductTraitState>(initialState),

  withMethods((store) => {
    const productTraitClient = inject(ProductTraitClient);

    return {
      async getProductTraits() {
        patchState(store, { loading: true });
        try {
          const productTraits = await firstValueFrom(productTraitClient.get());
          patchState(store, { productTraits, loading: false });
          return true;
        } catch {
          patchState(store, { loading: false });
          return false;
        }
      },

      async addProductTrait(productTrait: ProductTraitDto) {
        patchState(store, { loading: true });
        try {
          const productTraits = await firstValueFrom(productTraitClient.post(productTrait));
          patchState(store, { productTraits, loading: false });
          return true;
        } catch {
          patchState(store, { loading: false });
          return false;
        }
      },

      async updateProductTrait(productTrait: ProductTraitDto) {
        patchState(store, { loading: true });
        try {
          const productTraits = await firstValueFrom(productTraitClient.put(productTrait));
          patchState(store, { productTraits, loading: false });
          return true;
        } catch {
          patchState(store, { loading: false });
          return false;
        }
      },

      async deleteProductTrait(productTraitId: number) {
        patchState(store, { loading: true });
        try {
          const productTraits = await firstValueFrom(productTraitClient.delete(productTraitId));
          patchState(store, { productTraits, loading: false });
          return true;
        } catch {
          patchState(store, { loading: false });
          return false;
        }
      }
    };
  })
);
